function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
module.exports = function (modules) {
  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }
  var installedModules = {};
  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.i = function (value) {
    return value;
  }, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      configurable: !1,
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module["default"];
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 5);
}([function (module, exports) {
  module.exports = function (rawScriptExports, compiledTemplate, scopeId, cssModules) {
    var esModule,
      scriptExports = rawScriptExports = rawScriptExports || {},
      type = _typeof(rawScriptExports["default"]);
    "object" !== type && "function" !== type || (esModule = rawScriptExports, scriptExports = rawScriptExports["default"]);
    var options = "function" == typeof scriptExports ? scriptExports.options : scriptExports;
    if (compiledTemplate && (options.render = compiledTemplate.render, options.staticRenderFns = compiledTemplate.staticRenderFns), scopeId && (options._scopeId = scopeId), cssModules) {
      var computed = options.computed || (options.computed = {});
      Object.keys(cssModules).forEach(function (key) {
        var module = cssModules[key];
        computed[key] = function () {
          return module;
        };
      });
    }
    return {
      esModule: esModule,
      exports: scriptExports,
      options: options
    };
  };
}, function (module, exports, __webpack_require__) {
  __webpack_require__(10);
  var Component = __webpack_require__(0)(__webpack_require__(6), __webpack_require__(12), null, null);
  module.exports = Component.exports;
}, function (module, exports, __webpack_require__) {
  var Component = __webpack_require__(0)(__webpack_require__(7), __webpack_require__(11), null, null);
  module.exports = Component.exports;
}, function (module, exports, __webpack_require__) {
  var Component = __webpack_require__(0)(__webpack_require__(8), __webpack_require__(14), null, null);
  module.exports = Component.exports;
}, function (module, exports, __webpack_require__) {
  var Component = __webpack_require__(0)(__webpack_require__(9), __webpack_require__(13), null, null);
  module.exports = Component.exports;
}, function (module, exports, __webpack_require__) {
  "use strict";

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function install(Vue) {
    Vue.component("ContentPlaceholders", _ContentPlaceholders2["default"]), Vue.component("ContentPlaceholdersHeading", _ContentPlaceholdersHeading2["default"]), Vue.component("ContentPlaceholdersImg", _ContentPlaceholdersImg2["default"]), Vue.component("ContentPlaceholdersText", _ContentPlaceholdersText2["default"]);
  }
  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.ContentPlaceholdersText = exports.ContentPlaceholdersImg = exports.ContentPlaceholdersHeading = exports.ContentPlaceholders = void 0, exports.install = install;
  var _ContentPlaceholders = __webpack_require__(1),
    _ContentPlaceholders2 = _interopRequireDefault(_ContentPlaceholders),
    _ContentPlaceholdersHeading = __webpack_require__(2),
    _ContentPlaceholdersHeading2 = _interopRequireDefault(_ContentPlaceholdersHeading),
    _ContentPlaceholdersImg = __webpack_require__(3),
    _ContentPlaceholdersImg2 = _interopRequireDefault(_ContentPlaceholdersImg),
    _ContentPlaceholdersText = __webpack_require__(4),
    _ContentPlaceholdersText2 = _interopRequireDefault(_ContentPlaceholdersText);
  exports.ContentPlaceholders = _ContentPlaceholders2["default"], exports.ContentPlaceholdersHeading = _ContentPlaceholdersHeading2["default"], exports.ContentPlaceholdersImg = _ContentPlaceholdersImg2["default"], exports.ContentPlaceholdersText = _ContentPlaceholdersText2["default"];
  var plugin = {
    version: "0.2.1",
    install: install
  };
  exports["default"] = plugin;
  var GlobalVue = null;
  "undefined" != typeof window ? GlobalVue = window.Vue : "undefined" != typeof global && (GlobalVue = global.Vue), GlobalVue && GlobalVue.use(plugin);
}, function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports["default"] = {
    name: "content-placeholders",
    computed: {
      classObject: function classObject() {
        return {
          "vue-content-placeholders": !0,
          "vue-content-placeholders-is-rounded": this.rounded,
          "vue-content-placeholders-is-centered": this.centered,
          "vue-content-placeholders-is-animated": this.animated
        };
      }
    },
    props: {
      rounded: {
        type: Boolean,
        "default": !1
      },
      centered: {
        type: Boolean,
        "default": !1
      },
      animated: {
        type: Boolean,
        "default": !0
      }
    }
  };
}, function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports["default"] = {
    name: "content-placeholders-heading",
    data: function data() {
      return {
        className: "vue-content-placeholders-heading"
      };
    },
    props: {
      img: {
        type: Boolean,
        "default": !1
      }
    }
  };
}, function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports["default"] = {
    name: "content-placeholders-img",
    data: function data() {
      return {
        className: "vue-content-placeholders-img"
      };
    }
  };
}, function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports["default"] = {
    name: "content-placeholders-text",
    data: function data() {
      return {
        className: "vue-content-placeholders-text"
      };
    },
    props: {
      lines: {
        type: Number,
        "default": 4
      }
    }
  };
}, function (module, exports) {}, function (module, exports) {
  module.exports = {
    render: function render() {
      var _vm = this,
        _h = _vm.$createElement,
        _c = _vm._self._c || _h;
      return _c("div", {
        "class": _vm.className
      }, [_vm.img ? _c("div", {
        "class": _vm.className + "__img"
      }) : _vm._e(), _vm._v(" "), _c("div", {
        "class": _vm.className + "__content"
      }, [_c("div", {
        "class": _vm.className + "__title"
      }), _vm._v(" "), _c("div", {
        "class": _vm.className + "__subtitle"
      })])]);
    },
    staticRenderFns: []
  };
}, function (module, exports) {
  module.exports = {
    render: function render() {
      var _vm = this,
        _h = _vm.$createElement;
      return (_vm._self._c || _h)("div", {
        "class": _vm.classObject
      }, [_vm._t("default")], 2);
    },
    staticRenderFns: []
  };
}, function (module, exports) {
  module.exports = {
    render: function render() {
      var _vm = this,
        _h = _vm.$createElement,
        _c = _vm._self._c || _h;
      return _c("div", {
        "class": _vm.className
      }, _vm._l(_vm.lines, function (n) {
        return _c("div", {
          key: n,
          "class": _vm.className + "__line"
        });
      }));
    },
    staticRenderFns: []
  };
}, function (module, exports) {
  module.exports = {
    render: function render() {
      var _vm = this,
        _h = _vm.$createElement;
      return (_vm._self._c || _h)("div", {
        "class": _vm.className
      });
    },
    staticRenderFns: []
  };
}]);